var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAeroplaneLanding2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg3801",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 655.1 538.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:19.99px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-15.24 -109.29)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.35,
    y: 41.06,
    width: 606.64,
    height: 606.64
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3809"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3817"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3819",
    className: "cls-3",
    d: "M391.58,278.11c11.15,11.66,17.73,26.13,17.73,41.82,0,38.72-40.13,70.09-89.64,70.09S230,358.65,230,319.93c0-15.69,6.62-30.16,17.74-41.82a72.07,72.07,0,0,1,143.81,0Z",
    transform: "translate(-15.24 -109.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3823",
    className: "cls-3",
    d: "M354.84,278.11c-1.82-17.63-17-31.2-35.17-31.2s-33.35,13.57-35.16,31.2Z",
    transform: "translate(-15.24 -109.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3825"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3827",
    className: "cls-3",
    d: "M385.13,367.82C375.39,342.87,349.77,325,319.67,325S264,342.87,254.21,367.82",
    transform: "translate(-15.24 -109.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3831",
    className: "cls-3",
    d: "M107.88,278.11h-66c-19.88,0-24.38,30.23,0,33.12l61.36,7.22m144.52-40.34H148.15m5.3,46.25,78.29,9.24",
    transform: "translate(-15.24 -109.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3833"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3835",
    className: "cls-3",
    d: "M534.59,278.22l62.87-.11c19.89,0,24.39,30.23,0,33.12l-61.36,7.22m-144.69-40,102.91-.17m-8.43,46.08-78.46,9.57",
    transform: "translate(-15.24 -109.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3839",
    className: "cls-3",
    d: "M125.31,383.14A36.13,36.13,0,1,0,89.2,347,36.19,36.19,0,0,0,125.31,383.14Z",
    transform: "translate(-15.24 -109.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3841"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3843",
    className: "cls-3",
    d: "M514,383.14A36.13,36.13,0,1,0,477.9,347,36.18,36.18,0,0,0,514,383.14Z",
    transform: "translate(-15.24 -109.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3845"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3847",
    className: "cls-3",
    d: "M122,347h6.69",
    transform: "translate(-15.24 -109.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3851",
    className: "cls-3",
    d: "M510.68,347h6.68",
    transform: "translate(-15.24 -109.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3853"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3855",
    className: "cls-3",
    d: "M319.67,119.28V211",
    transform: "translate(-15.24 -109.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3863",
    className: "cls-3",
    d: "M632,540",
    transform: "translate(-15.24 -109.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3863-2",
    "data-name": "path3863",
    className: "cls-3",
    d: "M568,466.46",
    transform: "translate(-15.24 -109.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3867",
    className: "cls-3",
    d: "M319.67,390v39.1",
    transform: "translate(-15.24 -109.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3869"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3871",
    className: "cls-3",
    d: "M188.62,378.44v23m0-11.49h28.75m0-11.48v23M203,330.2v48.24",
    transform: "translate(-15.24 -109.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3873"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3875",
    className: "cls-3",
    d: "M422,378.44v23m0-11.49h28.75m0-11.48v23M436.35,330.2v48.24",
    transform: "translate(-15.24 -109.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3877"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3879",
    className: "cls-3",
    d: "M334.05,429.12v23",
    transform: "translate(-15.24 -109.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3881"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3883",
    className: "cls-3",
    d: "M305.3,429.12v23",
    transform: "translate(-15.24 -109.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3885"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3887",
    className: "cls-3",
    d: "M313.19,357.51h13",
    transform: "translate(-15.24 -109.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3889"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3891",
    className: "cls-3",
    d: "M183,203.69l91.69,23",
    transform: "translate(-15.24 -109.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3893"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3895",
    className: "cls-3",
    d: "M456.3,203.69l-91.69,23",
    transform: "translate(-15.24 -109.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3901"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3903",
    className: "cls-3",
    d: "M305.3,440.6h28.75",
    transform: "translate(-15.24 -109.29)"
  }))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M663.1,581.71l-28.76-14.2L619.43,546a13,13,0,0,0-10.91-5.94H368.59A11.41,11.41,0,0,0,359,545.3l-14.34,21.08L303,573.86l-.6.15a17.29,17.29,0,0,0-12.29,16.47v28.76a11.53,11.53,0,0,0,11.51,11.51h32.77a27.26,27.26,0,0,0,50.92,0h192a27.26,27.26,0,0,0,50.92,0h30.64a11.52,11.52,0,0,0,11.51-11.51V593.36A12.91,12.91,0,0,0,663.1,581.71ZM359.84,637.13A16.13,16.13,0,1,1,376,621,16.15,16.15,0,0,1,359.84,637.13Zm242.89,0A16.13,16.13,0,1,1,618.86,621,16.15,16.15,0,0,1,602.73,637.13Zm56.1-17.51H630a27.26,27.26,0,0,0-54.46,0H387.07a27.26,27.26,0,0,0-54.46,0h-31a.38.38,0,0,1-.37-.38V610h16.95a2.23,2.23,0,0,0,2.23-2.23v-8.91a2.23,2.23,0,0,0-2.23-2.23H301.24v-6.11a6.09,6.09,0,0,1,4.08-5.72l43.57-7.84a5.57,5.57,0,0,0,3.62-2.35L368.2,551.5l.1-.15a.35.35,0,0,1,.29-.16H608.52a1.83,1.83,0,0,1,1.56.86c0,.07.09.14.14.2L626,575a5.53,5.53,0,0,0,2.11,1.82l30,14.83a1.84,1.84,0,0,1,1,1.67v3.23h-7.3a2.22,2.22,0,0,0-2.22,2.23v8.91A2.22,2.22,0,0,0,651.9,610h7.3v9.28A.37.37,0,0,1,658.83,619.62Z",
    transform: "translate(-15.24 -109.29)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M598.08,558.61a8.14,8.14,0,0,0-6.71-3.52H376.69a8.1,8.1,0,0,0-6.92,3.83l-7.92,12.67a8.28,8.28,0,0,0,7,12.67H600a8.28,8.28,0,0,0,6.82-13Zm-108,7.61h55.69v6.91H490.08ZM479,573.13H423.26v-6.91H479Zm-100.61-6.91h33.78v6.91H374Zm178.57,6.91v-6.91H589.8l4.77,6.91Z",
    transform: "translate(-15.24 -109.29)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M366.78,621a6.94,6.94,0,1,1-6.94-7A6.94,6.94,0,0,1,366.78,621Z",
    transform: "translate(-15.24 -109.29)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M609.67,621a6.94,6.94,0,1,1-6.94-7A6.94,6.94,0,0,1,609.67,621Z",
    transform: "translate(-15.24 -109.29)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M412,589.61H400.15a5.57,5.57,0,0,0,0,11.13H412a5.57,5.57,0,0,0,0-11.13Z",
    transform: "translate(-15.24 -109.29)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M573.79,498.93a5.64,5.64,0,0,0,.84.46c7.76,3.43,12.58,8.8,14.33,16l1.41,5.74a6.71,6.71,0,0,0,6.53,5.13h0a6.7,6.7,0,0,0,6.53-5.13l1.41-5.74c1.75-7.15,6.57-12.52,14.33-16a5.73,5.73,0,0,0,.84-.46,7,7,0,0,0,0-11.59,5.73,5.73,0,0,0-.84-.46c-7.76-3.43-12.58-8.8-14.33-15.95l-1.41-5.74a6.71,6.71,0,0,0-6.53-5.13h0a6.72,6.72,0,0,0-6.54,5.13l-1.4,5.74c-1.75,7.15-6.57,12.52-14.33,15.95a4.86,4.86,0,0,0-.84.46,7,7,0,0,0,0,11.59Zm23.11-17.74a33.66,33.66,0,0,0,10.72,11.95,33.63,33.63,0,0,0-10.72,11.94,33.57,33.57,0,0,0-10.73-11.94A33.6,33.6,0,0,0,596.9,481.19Z",
    transform: "translate(-15.24 -109.29)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M650.54,526.21a7.12,7.12,0,1,1-7.12-7.12A7.12,7.12,0,0,1,650.54,526.21Z",
    transform: "translate(-15.24 -109.29)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M540.39,472.74a7.12,7.12,0,1,1-7.12-7.11A7.12,7.12,0,0,1,540.39,472.74Z",
    transform: "translate(-15.24 -109.29)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M520.54,451.4a7.12,7.12,0,1,1-7.12-7.11A7.11,7.11,0,0,1,520.54,451.4Z",
    transform: "translate(-15.24 -109.29)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAeroplaneLanding2);
export default __webpack_public_path__ + "static/media/aeroplane-landing-2.419de9146b2c59bb7328a77467c9fc8f.svg";
export { ForwardRef as ReactComponent };